module.exports = __webpack_public_path__ + "static/img/67.4dc3664.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/67.png
// module id = gyVx
// module chunks = 1